module.exports = __webpack_public_path__ + "assets/img/news (33).182ed93c.png";